import { render, staticRenderFns } from "./VideoShortsPanel.vue?vue&type=template&id=100522ae&scoped=true"
import script from "./VideoShortsPanel.vue?vue&type=script&lang=js"
export * from "./VideoShortsPanel.vue?vue&type=script&lang=js"
import style0 from "./VideoShortsPanel.vue?vue&type=style&index=0&id=100522ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100522ae",
  null
  
)

export default component.exports